import React from "react"
import { LinkStyle } from "./MiscStyle"

const Link = (props) => (
    <LinkStyle href={props.to}>{props.children ? props.children : props.to}</LinkStyle>
)

export default Link